<template>
  <header
    class="header bg-dark2 flex justify-between items-center w-full h-[60px] z-10"
    :class="{ 'header--hidden': isNavbarHidden, gradient }"
  >
    <Navigation
      :nav-items="navItems"
      gradient
      :navigation-type="navigationType"
    />
  </header>
</template>

<script setup lang="ts">
  import type { NavItem } from '@/types';
  import { onMounted, onUnmounted, ref } from 'vue';

  withDefaults(
    defineProps<{
      gradient?: boolean;
      navigationType: 'vendor' | 'base' | 'researcher';
      navItems: { regular: NavItem[]; mobile: NavItem[] };
    }>(),
    {
      gradient: false
    }
  );

  const lastScrollY = ref(0);
  const isNavbarHidden = ref(false);

  const handleScroll = () => {
    const currentScrollPosition = window.scrollY;
    isNavbarHidden.value = currentScrollPosition > lastScrollY.value;
    lastScrollY.value = currentScrollPosition;
  };

  onMounted(() => {
    window.addEventListener('scroll', handleScroll);
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
  });
</script>

<style scoped lang="scss">
  .gradient {
    background: radial-gradient(
      23% 250% at 0% 0%,
      rgba(36, 49, 0, 0.6) 0%,
      rgba(17, 18, 22, 0) 100%
    );
  }
  .header {
    background-color: theme('colors.dark2');
    position: fixed;
    transform: translate3d(0, 0, 0);
    transition: 0.3s all ease-out;
  }
  .header.header--hidden {
    transform: translateY(-100%);
  }
</style>
